// extracted by mini-css-extract-plugin
export var width100 = "x_w d_w";
export var design3Pos = "x_tQ d_0";